var _defs, _polygon, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutonomousLightPoint({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "15.9px",
    height: "8.8px",
    viewBox: "0 0 15.9 8.8",
    style: {
      enableBackground: "new 0 0 15.9 8.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n.cls-1{fill:#FFFFFF;stroke:#FFFFFF;stroke-miterlimit:10;stroke-width:0.5px;}\n"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "-0.1,0 -0.1,8.8 7.9,4.4",
    className: "cls-1"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "15.9,0 15.9,8.8 7.9,4.4",
    className: "cls-1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutonomousLightPoint);
export default __webpack_public_path__ + "static/media/AutonomousLightPoint.96cc3bd690c1231e95d86c8dfdfd334b.svg";
export { ForwardRef as ReactComponent };